import { Component, OnInit } from '@angular/core';
import { AbstractDialogComponent, ContentStoreService, DialogNgbService } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, take } from 'rxjs';
import { AwardSalesRequest } from 'src/app/core/model/core/award-sales-request';
import { SiteSettings } from 'src/app/core/model/site-settings';
import { User } from 'src/app/core/model/user';
import { UserStoreService } from 'src/app/core/store/user-store.service';

@Component({
  selector: 'app-award-sales-dialog',
  templateUrl: './award-sales-dialog.component.html',
  styleUrls: ['./award-sales-dialog.component.scss'],
})
export class AwardSalesDialogComponent extends AbstractDialogComponent implements OnInit {
  activeNonPrcUsers: User[];
  invoicesIds: number[];
  destinationUserId: number | null = null;
  destinationUserEmail: string | null = null;
  destinationUserEmailConfirmation: string | null = null;
  emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  invitePartnerSection: string;
  enableInvitePartner = false;

  buttonLabel = 'Award';

  constructor(
    private userStore: UserStoreService,
    public activeModal: NgbActiveModal,
    private dialog: DialogNgbService,
    private contentStore: ContentStoreService
  ) {
    super();
  }

  ngOnInit() {
    this.activeNonPrcUsers = this.inputs?.find(
      (item) => item.activeNonPrcUsers !== null && item.activeNonPrcUsers !== undefined
    ).activeNonPrcUsers;
    this.invoicesIds = this.inputs?.find(
      (item) => item.selectedInvoicesIds !== null && item.selectedInvoicesIds !== undefined
    ).selectedInvoicesIds;
    this.invitePartnerSection = this.inputs?.find(
      (item) => item.invitePartnerSection !== null && item.invitePartnerSection !== undefined
    ).invitePartnerSection;

    this.contentStore.siteSettings$.pipe(filter(Boolean), take(1)).subscribe((settings) => {
      const { siteSettings } = settings as SiteSettings;
      if (siteSettings.enableInvitePartner !== undefined) {
        this.enableInvitePartner = siteSettings.enableInvitePartner;
      }
    });
  }

  awardInvoice() {
    if (this.destinationUserId == null && this.destinationUserEmail == null) {
      this.dialog.openError(['Please select a user from a dropdown or invite a team member']);
      return;
    }

    if (this.destinationUserEmail && this.destinationUserEmail !== this.destinationUserEmailConfirmation) {
      this.dialog.openError(['The email addresses must match']);
      return;
    }

    const awardRequest = new AwardSalesRequest();
    awardRequest.destinationUserId = this.destinationUserId;
    awardRequest.destinationUserEmail = this.destinationUserEmail;
    awardRequest.invoiceIds = this.invoicesIds;
    awardRequest.showClaim = true;
    awardRequest.showUnclaim = false;
    this.userStore.awardInvoice(awardRequest).then((success) => {
      if (success) {
        if (awardRequest.destinationUserEmail !== null) {
          this.dialog.openNotification(['Award_sale_invited_message'], 'Important').then(() => this.onCancel(true));
        } else {
          this.dialog.openNotification(['Sales Invoices Awarded.'], 'Important').then(() => this.onCancel(true));
        }
      } else {
        this.dialog.openNotification(['Awarding failed.'], 'Important').then(() => this.onCancel(false));
      }
    });
  }

  onCancel(searchItems: boolean) {
    this.activeModal.close(searchItems);
  }

  selectedUser(userEmail: string) {
    if (this.emailRegex.test(userEmail)) {
      const existingUser = this.activeNonPrcUsers.find((u) => u.email === userEmail);

      if (existingUser) {
        this.destinationUserId = existingUser.id!;
        this.destinationUserEmail = null;
        this.buttonLabel = 'Award';
      } else {
        this.destinationUserId = null;
        this.destinationUserEmail = userEmail;
        this.buttonLabel = 'Invite';
      }
    } else {
      this.buttonLabel = 'Award';
      this.destinationUserId = null;
      this.destinationUserEmail = null;
    }
  }

  onInput(email: string) {
    this.destinationUserEmailConfirmation = email;
  }
}
